if (!customElements.get('zoae-motion-slideshow')) {
    customElements.define('zoae-motion-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.buttons = [...this.querySelectorAll('[data-go]')];
        this.pauseButton = this.querySelector('[data-pause]');
        this.index = 0;
        this.inView = true;
        this.focused = false;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motionQuery.matches;
        this.canAdvance = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.canPlayVideo = this.dataset.videoAutoplay === 'true';
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.pauseButton.hidden = !(this.canAdvance || this.canPlayVideo && this.querySelector('video'));
        this.buttons.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.go)), options));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motionQuery.addEventListener('change', event => { this.paused = event.matches; this.sync(); }, options);
        this.slides.forEach(slide => {
          const video = slide.querySelector('video');
          if (video) {
            video.addEventListener('playing', () => video.classList.add('is-ready'), options);
            video.addEventListener('error', () => video.classList.remove('is-ready'), options);
          }
        });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.paused = true; this.show(index); }
        }, options);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: .05 });
        this.observer.observe(this);
        this.sync();
      }
      show(index) {
        this.index = index;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          if (this.buttons[position]) this.buttons[position].setAttribute('aria-current', String(active));
        });
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        const running = !this.paused && this.inView && !document.hidden;
        this.slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (running && this.canPlayVideo && index === this.index) {
            video.muted = true;
            video.play().catch(() => {});
          } else video.pause();
        });
        if (running && this.canAdvance && !this.focused) this.timer = setTimeout(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.interval) || 30000);
        this.pauseButton.querySelector('[data-pause-label]').textContent = this.paused ? 'Play' : 'Pause';
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow and video' : 'Pause slideshow and video');
      }
      disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.abort?.abort(); }
    });
  }
